import vars from '../globals';

let decRate = 30;
// let parallaxState = false;
// let resizeTimeout = null;
// const parallaxItemList = [...document.querySelectorAll('.leaf.isActive')];

const getTweenPapallaxParams = (posY) => {
	return vars.isIEorEdge ? {
		ease: Power0.easeNone,
		y: posY,
	} : {
		y: posY,
		rotationZ: -0.0001,
	};
};

const updatePosition = (elements) => {
	let windowScrollTop = window.pageYOffset;

	let windowHeight = window.innerHeight;

	let windowScrollBottom = windowScrollTop + windowHeight;

	[...elements].forEach((element) => {
		let elementOffsetTop = element.getBoundingClientRect().top;
		let elementHeight = element.offsetHeight;
		let elementOffsetBottom = elementOffsetTop + elementHeight;

		if (elementOffsetTop < windowHeight && elementOffsetBottom > 0) {
			// Центровка по экрану
			let half = windowHeight / 2 + elementHeight / 2;
			let posY = Math.round((windowScrollBottom - elementOffsetTop - half) / decRate);

			TweenMax.to(element, 0.25, getTweenPapallaxParams(posY));
		}
	});
};

const initParallax = (elements) => {
	vars.$window.on('scroll.parallax', () => {
		updatePosition(elements);
	});

	// parallaxState = true;
};

const destroyParallax = (elements) => {
	vars.$window.off('.parallax');

	TweenMax.killTweensOf(elements);
	TweenMax.set(elements, {clearProps: 'all'});

	// parallaxState = false;
};

// window.addEventListener('resize', () => {
// 	if (resizeTimeout) {
// 		clearTimeout(resizeTimeout);
// 	}

// 	resizeTimeout = setTimeout(() => {
// 		if (!vars.isMobile() && !parallaxState) {
// 			initParallax(parallaxItemList);
// 		} else if (vars.isMobile() && parallaxState) {
// 			destroyParallax(parallaxItemList);
// 		}
// 	}, 500);
// });

export {
	initParallax,
	destroyParallax,
};
